var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "FrameResults" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.loading } },
        [
          _c(
            "b-row",
            { staticClass: "frame-result-row grid" },
            _vm._l(_vm.results, function (moulding) {
              return _c(
                "a",
                {
                  key: moulding.sku,
                  staticClass: "col-sm-6 col-md-4 col-lg-3 col-xl-2",
                  attrs: { sm: "6", md: "4", lg: "3", xl: "2" },
                },
                [
                  _c("frame-result", {
                    attrs: {
                      moulding: moulding,
                      "rebate-size": _vm.rebateSize,
                      "aperture-size": _vm.apertureSize,
                      "to-fit-size": _vm.artworkSize,
                      "mount-width": _vm.filter.mountWidth,
                      mountboard:
                        _vm.filter.mountType == "single"
                          ? _vm.filter.mountColour
                          : null,
                    },
                    on: { "load-designer": _vm.loadDesigner },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c("b-pagination", {
        attrs: {
          align: "center",
          "total-rows": _vm.rows,
          "per-page": _vm.perPage,
        },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }